/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    note: {},
    history: [],
}

const GlobalNoteSlice = createAppSlice({
    name: 'gdl/globalNote',
    initialState,
    reducers: (create) => ({
        fetchGlobalNote: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.globalNote())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement de la note partagée')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.note = action.payload ?? {}
                },
            },
        ),
        saveGlobalNote: create.asyncThunk(
            async (note, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.globalNote(), { body: note, method: 'PUT' })
                    toast.success('Note enregistrée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de l\'enregistrement de la note partagée')
                    return rejectWithValue(err)
                }
            },
            {
                // Nouvelle version persistée : on reflète la version courante sans recharger.
                fulfilled: (state, action) => {
                    const { comment, updateLogin } = action.meta.arg
                    state.note = { id: action.payload?.id, comment, updateLogin, updateDate: Date.now() }
                },
            },
        ),
        fetchGlobalNoteHistory: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.globalNoteHistory())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement de l\'historique de la note')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: (state, action) => {
                    state.history = action.payload ?? []
                },
            },
        ),
    }),
    selectors: {
        selectGlobalNote: state => state.note,
        selectGlobalNoteHistory: state => state.history,
    },
})

export const { fetchGlobalNote, saveGlobalNote, fetchGlobalNoteHistory } = GlobalNoteSlice.actions
export const { selectGlobalNote, selectGlobalNoteHistory } = GlobalNoteSlice.getSelectors(state => state.gdl.globalNote)

export default GlobalNoteSlice
